import StreamingLessonMedia from './component'
export default StreamingLessonMedia
